// generated by genversion
export var version = '4.3.1';
//# sourceMappingURL=version.js.map